import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment';

export const addEditExOpReceiptModalSlice = createSlice({
    name: 'addEditExOpReceiptModal',
    initialState: {
        showModal: false,
        title: 'New Receipt',
        client: null,
        todayDate: moment().format('YYYY-MM-DD'),
        editMode: false,
        external_receipt_details: [],
        er_type: null,
        er_ref: '',
        selectedServicesData: [],
        selectedJournalTypeData: null,
        er_desc: '',
        er_attachment: '',
        er_attachment_prev: '',
    },
    reducers: {
        toggleReceiptModal: (state, action) => {
            state.showModal = !state.showModal
            state.title = (action.payload && action.payload.title) ? action.payload.title : 'New Receipt'
            state.todayDate = (action.payload && action.payload.todayDate) ? action.payload.todayDate : moment().format('YYYY-MM-DD')
            state.client = (action.payload && action.payload.client) ? action.payload.client : null
            state.editMode = (action.payload && action.payload.editMode) ? action.payload.editMode : false
            state.external_receipt_details = (action.payload && action.payload.external_receipt_details) ? action.payload.external_receipt_details : []
            state.er_type = (action.payload && action.payload.er_type) ? action.payload.er_type : null
            state.er_ref = (action.payload && action.payload.er_ref) ? action.payload.er_ref : ''
            state.er_desc = (action.payload && action.payload.er_desc) ? action.payload.er_desc : ''
            state.er_attachment = (action.payload && action.payload.er_attachment) ? action.payload.er_attachment : ''
            state.er_attachment_prev = (action.payload && action.payload.er_attachment_prev) ? action.payload.er_attachment_prev : ''
            state.selectedServicesData = (action.payload && action.payload.selectedServicesData) ? action.payload.selectedServicesData : []
            state.selectedJournalTypeData = (action.payload && action.payload.selectedJournalTypeData) ? action.payload.selectedJournalTypeData : null
        },
        updateClient: (state, action) => {
            state.client = (action.payload) ? action.payload : null
        }
    },
});

export const { toggleReceiptModal, updateClient } = addEditExOpReceiptModalSlice.actions;
export default addEditExOpReceiptModalSlice.reducer;
